var _excluded = ["models"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import dva from 'dva';
import createLoading from 'dva-loading';
export default function createDvaApp(App, dvaAppOptions) {
  var models = dvaAppOptions.models,
    config = _objectWithoutProperties(dvaAppOptions, _excluded);
  var app = dva(config);
  app.use(createLoading());
  models.map(function (model) {
    return app.model(model);
  });
  app.router(App);
  var DvaApp = app.start();
  window.g_app = app;
  return DvaApp;
}